import React from 'react';

import Parallax from '../common/Parallax.jsx';

function BlogImageParallaxComponent(props) {
    let blog = props.data || {};
    if (blog.blog) {
        blog = blog.blog;
    }
    return <Parallax.ImageContainer.Component {...props} data={[{ blog,  image: blog.featured }]} slideComponent={BlogImageParallaxCell} />
}

function BlogImageParallaxCell(props) {
    let data = props.data;
    if (data && data.blog) {
        data = data.blog;
    }
    let blockConfig = props.blockConfig;
    if (!blockConfig && props.parentBlock) {
        blockConfig = props.parentBlock.config;
    }
    return <Parallax.ImageContainer.Cell {...props} image={data.featured} />
}

export default { Cell: BlogImageParallaxCell, Component: BlogImageParallaxComponent };